import {
  NEW_REFERRAL_RECEIVED,
  NEW_REFERRALS_ACKNOWLEDGED,
} from 'agent_portal/actions/NewReceivedReferralsActions';

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case NEW_REFERRAL_RECEIVED: {
      const { referralId, receivedAt } = action;
      return [...state, { referralId, receivedAt }];
    }

    case NEW_REFERRALS_ACKNOWLEDGED:
      return initialState;

    default:
      return state;
  }
}
